const requiredRuntimeValue = (name) => {
    const value = process.env[name];

    if (!value) {
        throw new Error(`Missing required runtime configuration: ${name}`);
    }

    return value;
};

export const functionsBaseUrl = requiredRuntimeValue(
    "REACT_APP_FUNCTIONS_BASE_URL"
).replace(/\/$/, "");

export { requiredRuntimeValue };
